import { helpers, required } from "@vuelidate/validators";

import useVuelidate from "@vuelidate/core";
import { storeToRefs } from "pinia";
import { useNotificationsStore } from "~/store/notifications/notifications.store";
import { typeNotications } from "~/utils/enums/notifications.enums";

export const useNotificationsValidation = () => {
  async function sessionNotifications() {
    const notificationsStore = useNotificationsStore();
    const { createSession, type } = storeToRefs(notificationsStore);

    if (type.value === typeNotications.session) {
      const rules = computed(() => {
        return {
          subject: {
            required: helpers.withMessage("Ce champ est obligatoire", required),
          },
        };
      });

      const v$ = useVuelidate(rules, createSession.value);
      await v$.value.$validate();

      return v$;
    }
  }
  return {
    sessionNotifications,
  };
};
